/**
 * from raw namespace string to formatted {project}@{namespace}
 * e.g
 * Multi projects
 * {
 *   i18n_ecom_shop_fe: 'i18n_ecom_shop@fe',
 *   i18n_ecom_shop_kyc_tax: 'i18n_ecom_shop@kyc_tax',
 * }
 *
 * Single project
 * {
 *   fe: 'i18n_ecom_shop@fe',
 *   kyc_tax: 'i18n_ecom_shop@kyc_tax',
 * }
 */
export var getNamespaceMap = function (projects) {
    if (projects.length === 1) {
        return projects[0].namespace.reduce(function (acc, ns) {
            acc[ns] = "".concat(projects[0].projectName, "@").concat(ns);
            return acc;
        }, {});
    }
    var map = projects.reduce(function (acc, item) {
        item.namespace.forEach(function (n) {
            acc["".concat(item.projectName, "_").concat(n)] = "".concat(item.projectName, "@").concat(n);
        });
        return acc;
    }, {});
    return map;
};
export var getNamespaceApiInfoMap = function (projects) {
    var map = projects.reduce(function (acc, item) {
        item.namespace.forEach(function (ns) {
            acc["".concat(item.projectName, "@").concat(ns)] = {
                apiKey: item.apiKey,
                namespace: ns,
            };
        });
        return acc;
    }, {});
    return map;
};
